export interface ZoneOfInterestDto {
  id: number;
  name: string;
  type: number;
  geometryType: string;
  centerX?: number;
  centerY?: number;
  radius?: number;
  wktString?: string;
  detectionThresholdSeconds: number;
  isActive: boolean;
}

export enum ZoneOfInterestType {
  Crusher = 0,
  Garage = 1
}
